//#region types
import { MinMaxAmountSectionViewProps } from "models/propTypes/automationRulePropTypes";
import { CurrencyInputProps } from "models/propTypes/wintFormPropsTypes";
import { CurrencyEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { VerticalFormField, CurrencyInput, Description } from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { IconDefinitionConstants } from "utils/constants";
import cssExports from "theme/styles/main.module.scss";

const MinMaxAmountSection: React.FC<MinMaxAmountSectionViewProps> = (props) => {
  const { minAmount, maxAmount } = props;

  return (
    <Grid container direction="column" className={cssExports.formContainer}>
      <Grid item container direction="row" spacing={1}>
        <Grid item xs={6}>
          <VerticalFormField<CurrencyInputProps>
            Component={CurrencyInput}
            {...minAmount}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.LowestAmount)}
            currency={CurrencyEnums.CurrencyCode.SEK}
            icon={IconDefinitionConstants.WVat}
            optional
          />
        </Grid>
        <Grid item xs={6}>
          <VerticalFormField<CurrencyInputProps>
            Component={CurrencyInput}
            {...maxAmount}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.HighestAmount)}
            currency={CurrencyEnums.CurrencyCode.SEK}
            icon={IconDefinitionConstants.WVat}
            optional
          />
        </Grid>
      </Grid>
      <Grid item>
        <Description horizontal>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AutomationRule.MinMaxDescription)}
        </Description>
      </Grid>
    </Grid>
  );
};

export default MinMaxAmountSection;
